import { useEffect } from "react";
import { Header } from "./Header";
import { ContactAndFooter } from "./ContactAndFooter";
import { Reveal } from "./Reveal";

export const LegalPage = ({ eyebrow, title, updated, sections, testid }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div data-testid={testid} className="bg-[#fafafa] min-h-screen">
      <Header />
      <section className="relative bg-[#090d16] grain pt-40 pb-20 overflow-hidden">
        <div className="mx-auto max-w-4xl px-5 sm:px-8 text-center sm:text-left">
          <p className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-green-400 mb-4">{eyebrow}</p>
          <h1 className="font-display font-extrabold text-white text-4xl sm:text-6xl tracking-tight">{title}</h1>
          <p className="mt-4 text-slate-400 text-sm">Senast uppdaterad: {updated}</p>
        </div>
      </section>
      <section className="py-16 sm:py-24">
        <div className="mx-auto max-w-4xl px-5 sm:px-8 flex flex-col gap-10">
          {sections.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <div data-testid={`${testid}-section-${i}`} className="border-b border-slate-200 pb-8">
                <h2 className="font-display font-bold text-xl sm:text-2xl text-[#0b0f19]">{s.title}</h2>
                <p className="mt-3 text-sm sm:text-base leading-relaxed text-slate-600">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <ContactAndFooter />
    </div>
  );
};
